<template>
    <confirm-modal
        :confirm-text="trans('workorder.modal.resolve_preventative.confirm')"
        :name="name"
        :title="trans('workorder.modal.resolve_preventative.title')"
        @cancel="handleCancel"
        @confirm="handleConfirm"
    >
        <div class="mb-3">{{ trans('workorder.modal.resolve_preventative.description') }}</div>
        <jet-datepicker
            v-model="resolvedDate"
            :deletable="false"
            :horizontal="false"
            :label="trans('workorder.modal.resolve_preventative.date_label')"
            :max-date="today"
            :required="true"
        />
    </confirm-modal>
</template>

<script>
import ConfirmModal from '@/Components/ConfirmModal.vue';
import JetDatepicker from '@/Jetstream/Datepicker.vue';
import { trans } from '@/mixins/i18n.js';
import { visitModal } from '@inertiaui/modal-vue';
import { DateTime } from 'luxon';

export default {
    components: {
        ConfirmModal,
        JetDatepicker,
    },
    props: {
        name: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            today: null,
            resolvedDate: null,
            onConfirmCb: null,
            onCancelCb: null,
        };
    },
    methods: {
        open({ workOrder = null, onConfirm = null, onCancel = null } = {}) {
            this.onConfirmCb = onConfirm;
            this.onCancelCb = onCancel;
            // Anchor "today" to the work order's airport timezone (when known) so the default and
            // max date line up with the backend's location-timezone validation boundary.
            this.today = DateTime.now()
                .setZone(workOrder?.timezone || 'local')
                .toFormat('yyyy-MM-dd');
            this.resolvedDate = this.today;
            visitModal('#' + this.name);
        },
        handleConfirm() {
            this.onConfirmCb && this.onConfirmCb(this.resolvedDate);
            this.reset();
        },
        handleCancel() {
            this.onCancelCb && this.onCancelCb();
            this.reset();
        },
        reset() {
            this.resolvedDate = null;
            this.onConfirmCb = null;
            this.onCancelCb = null;
        },
    },
};
</script>
